export default __webpack_public_path__ + "static/media/youchien.b887df96.jpg";